/**
 * Paid Ads add-on tier pricing - display values mirror the Stripe Payment
 * Links configured in `backend/stripe_integration.PAID_ADS_LINKS`.
 * Monthly subscriptions only.
 */

export const PAID_ADS_TIERS = [
  {
    id: 'starter',
    label: 'Starter Ads',
    positioning: 'Manage ad budget up to €2,000/month',
    bullets: [
      'Google Ads + Meta (Facebook / Instagram) + ChatGPT (OpenAI) Ads',
      'Campaign setup across 1-2 channels',
      'Ad creatives & copy included',
      'Conversion tracking setup (forms, calls)',
    ],
    price: { gbp: 429, eur: 499, usd: 549 },
  },
  {
    id: 'growth',
    label: 'Growth Ads',
    positioning: 'Manage ad budget up to €5,000/month',
    featured: true,
    bullets: [
      'Google Ads + Meta + ChatGPT (OpenAI) Ads',
      'Multi-channel campaign setup',
      'Creatives + variations (static, carousel, basic video)',
      'Advanced tracking + audience setup',
    ],
    price: { gbp: 779, eur: 899, usd: 999 },
  },
];

export const PA_CURRENCY_SYMBOL = { gbp: '£', eur: '€', usd: '$' };
